export const Header = () => (
  <header className="site-header" data-testid="site-header">
    <div className="container-x flex items-center justify-between" style={{ minHeight: 68, gap: "1rem" }}>
      <a href="#top" className="wordmark" data-testid="header-wordmark">
        Get Front <span className="wm-accent">Desk</span>
      </a>
      <nav className="site-nav" aria-label="Sections" data-testid="site-nav">
        <a href="#catch-every-call" data-testid="nav-catch-every-call">Catch Every Call</a>
        <a href="#past-customers" data-testid="nav-past-customers">Past Customers</a>
        <a href="#get-found" data-testid="nav-get-found">Get Found</a>
      </nav>
      <a href="#demo" className="btn btn-primary header-cta" data-testid="header-hear-front-desk-btn">
        Hear your own front desk
      </a>
    </div>
  </header>
);
